// extracted by mini-css-extract-plugin
export var animationAbsolute = "_22-q";
export var animationRelative = "_22-p";
export var backdropBlur = "_22-0";
export var detailLabelCell = "_22-12";
export var detailTable = "_22-11";
export var detailValueCell = "_22-13";
export var docIconBox = "_22-1d";
export var docIconBoxMd = "_22-1f";
export var docIconBoxSm = "_22-1e";
export var docTypeRow = "_22-16";
export var docTypeRowInner = "_22-17";
export var dropdownMatchDatePicker = "_22-3";
export var evidenceCardContent = "_22-1c";
export var fileUploadSpin = "_22-j";
export var gorgiasOpenButton = "_22-15 _22-d";
export var gorgiasTicketCard = "_22-14";
export var heroModalFooterButton = "_22-18";
export var hiddenContainer = "_22-o";
export var iconPrimary = "_22-1g";
export var iconSecondary = "_22-1h";
export var iconTertiary = "_22-1i";
export var integrationCard = "_22-1";
export var integrationLogoBox = "_22-2";
export var mainColumnSticky = "_22-1b";
export var maxWidthContainer = "_22-19";
export var modalContentBody = "_22-a";
export var modalHeaderImage = "_22-5";
export var modalImageLabel = "_22-7";
export var modalImageOverlay = "_22-6";
export var modalImageSubtitle = "_22-9";
export var modalImageTitle = "_22-8";
export var modalImageWrapper = "_22-4";
export var modalStickyFooter = "_22-b";
export var removeButton = "_22-e";
export var sidebarColumn = "_22-1a";
export var spinner = "_22-i";
export var timelineLine = "_22-y";
export var timelineLineBlack = "_22-10 _22-y";
export var timelineLineGray = "_22-z _22-y";
export var timelineLineHeight = "_22-x";
export var tlDotActivate = "_22-u";
export var tlDotActivateAnim = "_22-t";
export var tlDotHide = "_22-s";
export var tlDotHideAnim = "_22-r";
export var tlLineActivate = "_22-w";
export var tlLineActivateAnim = "_22-v";
export var uploadHint = "_22-n";
export var uploadIconBox = "_22-k";
export var uploadLabel = "_22-m";
export var uploadText = "_22-l";
export var uploadZone = "_22-f";
export var uploadZoneCursorDefault = "_22-h";
export var uploadZoneCursorPointer = "_22-g";
export var uploadedFileRow = "_22-c";
export var viewButton = "_22-d";